// extracted by mini-css-extract-plugin
module.exports = {"shadow":"ServicesPage_shadow__2bEv9","row":"ServicesPage_row__3qYTR"};